class subcollection extends HTMLElement {
  constructor() {
    super();
    this.collectionCarousel();
  }

  collectionCarousel() {
    var subslider = new Swiper(".subcollection-slider__swiper", {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 6,
          spaceBetween: 47
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

customElements.define('subcollection-slider', subcollection);